import { render } from "./member-reports.vue?vue&type=template&id=0674a441"
import script from "./member-reports.vue?vue&type=script&lang=js"
export * from "./member-reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__